// TODO: This needs to be set in balancing/uiDefinitions!!!
import { IdLeagueGifts } from "../../constants/IdLeagueGifts";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { EventType } from "../balancing/types/BalancingCore";
export var mapDialogLeagueRewardsDescription = new Map([
    [
        EventType.PlayerLeague,
        new Map([
            [IdLeagueGifts.LeagueFreeGift, undefined],
            [IdLeagueGifts.LeagueGoldGift, IdLoca.leagueReward_goldPackage_desc],
        ]),
    ],
    [
        EventType.CoopLeague,
        new Map([
            [IdLeagueGifts.LeagueFreeGift, undefined],
            [IdLeagueGifts.LeagueGoldGift, IdLoca.coopLeagueReward_goldPackage_desc],
        ]),
    ],
    [
        EventType.CollectLeague,
        new Map([
            [IdLeagueGifts.LeagueFreeGift, undefined],
            [IdLeagueGifts.LeagueGoldGift, IdLoca.collectLeagueReward_goldPackage_desc],
        ]),
    ],
]);



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/MapDialogLeagueRewardsDescription.tsx
// module id = 2945
// module chunks = 3